import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Brush02 = function Brush02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M18 10V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C17.2401 2 16.9601 2 16.4 2H7.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C6 2.76 6 3.04 6 3.6V10m12 0H6m12 0v.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C15.7202 15 14.8802 15 13.2 15h-2.4c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C6 12.7202 6 11.8802 6 10.2V10m8.5 5v4.5c0 1.3807-1.1193 2.5-2.5 2.5s-2.5-1.1193-2.5-2.5V15"
    })
  }));
};
export default Brush02;